import config from "../config";
//auth
export const POST_FAKE_LOGIN = "/post-fake-login";
export const POST_FAKE_JWT_LOGIN = "/post-jwt-login";
export const POST_FAKE_PASSWORD_FORGET = "/fake-forget-pwd";
export const POST_FAKE_JWT_PASSWORD_FORGET = "/jwt-forget-pwd";
export const SOCIAL_LOGIN = "/social-login";
export const JWT_REGISTER = "/post-jwt-register";
export const POST_FAKE_REGISTER = "/post-fake-register";

export const USER_CHANGE_PASSWORD = "/user-change-password";

//
export const GET_QUICKREPLIES = "DootChat/QuickReplies";

// profile & settings
export const GET_PROFILE_DETAILS = "User/1";
export const GET_USER_SETTINGS = "user/1";
export const UPDATE_SETTINGS = "user";

//https://bkservice.rwconsultoria.com.br/api/DootChat/Contacts

// 📁 SOCKET: https://bkservice.rwconsultoria.com.br/api/chatHub
export const API_SOCKET = config.API_URL + "chatHub";

// export const LINK_ATTACHMENTS = "https://acesso.rwconsultoria.com.br/files/zcred/";
export const LINK_ATTACHMENTS =
  "https://zconnect.rwconsultoria.com.br/files/zcred/";

// 📁 LOGIN
export const API_USER_LOGIN = "User/Login";
export const API_USER_AUTH = "User/Auth";
export const API_USER_AVATAR = "User/Avatar";
export const API_USER_COVER = "User/Cover";

// 📁 SESSION
export const SESSION = "DootChat/Sessions";
export const SESSION_OPEN = "DootChat";

// 📁 CONTATOS
export const GET_CONTACTS = "Contact"; // GET lista de contatos
export const READ_CONVERSATION = "Contact"; // PUT marcar conversas como lida
export const INVITE_CONTACT = "Contact"; // POST novo contato

// 📁 BOOKMARK
export const BOOKMARK = "Bookmark"; //BOOKMARK

// 📁 MENSAGENS / CONVERSAS
export const MESSAGES = "Message"; // GET mensagens por contato/usuario

export const GET_MESSAGES = "DootChat/Message"; // GET mensagens por contato
export const SEND_MESSAGE_DIRECT = "DootChat/SendTextDirect"; // POST nova mensagem
export const SEND_MESSAGE_MEDIA = "DootChat/SendMediaDirect"; // POST nova mensagem (ANEXO)
export const SEND_MESSAGE_MEDIA_TEMPLATE = "DootChat/SendAudioTemplate"; // POST nova mensagem (AUDIO)
export const SEND_MESSAGE_CLOSE = "DootChat/SendCloseSession"; //POST encerra sessao
export const SEND_MESSAGE_TRANSFER_SESSION = "DootChat/TransferSession"; //POST transfere sessao
export const SEND_MESSAGE_REACTION = "DootChat/SendReaction"; //POST mensagem reaction (Emoji)
export const SEND_MESSAGE_TEMPLATE = "DootChat/SendTemplate"; //POST mensagem template

export const RECEIVE_MESSAGE = "Message"; //GET novas mensagens (s/ atribuicao idUser sessions )
export const FORWARD_MESSAGE = "DootChat/Messages/Forward"; // POST encaminhar mensagem
export const DELETE_MESSAGE = "DootChat/Messages/Delete"; // DELETE mensagem individual
export const DELETE_USER_MESSAGES = "DootChat/Messages/User"; // DELETE todas mensagens do contato
export const DELETE_IMAGE = "DootChat/Messages/DeleteImage"; // DELETE imagem da mensagem

// 📁 CANAIS / GRUPOS (mantido para compatibilidade visual)
export const GET_CHANNELS = "DootChat/Channels"; // GET canais
export const CREATE_CHANNEL = "DootChat/Channels"; // POST novo canal
export const GET_CHANNEL_DETAILS = "DootChat/Channels/Details"; // GET detalhes canal

// 📁 CONVERSAS / DETALHES
export const GET_CHAT_USER_DETAILS = "/DootChat/Conversations/User"; // GET detalhes de um contato/conversa
export const GET_CHAT_USER_CONVERSATIONS = "/DootChat/Conversations"; // GET lista de mensagens da conversa
